<li class="booking-info-list-item">
  @if (icon) {
    <markant-icon
      class="booking-info-list-item-icon"
      [icon]="icon"
    ></markant-icon>
  }
  <ng-content></ng-content>
</li>
